/**
 * Small shared helpers for the backup widget + backups page. Kept in a
 * separate file so both consumers can import without a circular ref.
 */

export function formatRelative(isoString) {
  if (!isoString) return "never";
  const then = new Date(isoString).getTime();
  if (Number.isNaN(then)) return "unknown";
  const diffMs = Date.now() - then;
  const sec = Math.max(0, Math.round(diffMs / 1000));
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 48) return `${hr} hr ago`;
  const day = Math.round(hr / 24);
  return `${day} day${day === 1 ? "" : "s"} ago`;
}

export function formatBytes(n) {
  const b = Number(n) || 0;
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MB`;
  return `${(b / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function absoluteTimestamp(isoString) {
  if (!isoString) return "—";
  try {
    return new Date(isoString).toISOString().replace("T", " ").slice(0, 19) + " UTC";
  } catch {
    return isoString;
  }
}
